import { createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img/logo-w.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("a", {
  href: "",
  class: "main-logo"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<a href=\"#home\">Home</a><a href=\"#portfolio\">Cases</a><a href=\"#services\">Services &amp; Solutions</a><a href=\"#clients\">Clients</a><a href=\"#joboffers\">Career</a><a href=\"#contact\">Contact</a>", 6)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("span", {
      class: "visible-xs hamburger",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMenu()))
    }, [
      _createVNode("i", {
        class: ["icon-menu2", { 'is-off': _ctx.isHamburgerMenuOn }]
      }, null, 2),
      _createVNode("i", {
        class: ["icon-cross3", { 'is-off': !_ctx.isHamburgerMenuOn }]
      }, null, 2)
    ]),
    _createVNode("div", {
      class: ["stickynav type-black", { 'mobile-menu isVisible': _ctx.isHamburgerMenuOn }]
    }, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("nav", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeMenu()))
        }, [
          _hoisted_3
        ])
      ])
    ], 2)
  ], 64))
}